var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-card',{staticClass:"spacer-margin"},[_c('ui-heading',{attrs:{"no-top-margin":""}},[_vm._v(_vm._s(this.heading))]),_vm._l((Object.keys(_vm.tree)),function(key,index){return _c('screening-details-child',{key:`${index}-${key}`,attrs:{"itemKey":key,"itemValue":_vm.tree[key]}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }